function ProjectsPage() {
  return (
    <>
      <div className="projects-page container" style={{ zIndex: 300000 }}>
        <h1 className="projects-page__title title">This is Projects page</h1>
      </div>
    </>
  );
}

export default ProjectsPage;
